import { configureStore } from "@reduxjs/toolkit";
import { languageReducer, loaderReducer, loginSignUpReducer, guestSignupReducer, locationReducer, locationNameReducer, locationRadiusReducer, childLoginRestrictionReducer, notificationRefreshReducer, s3DataKeyReducer, filterReducer, initFilterReducer, TermsandConditionsReducer, ErrorNotificationReducer, googleMapLoadedReducer } from "../Reducer/Reducer";

export const store = configureStore({
  reducer: { languageReducer, loaderReducer, loginSignUpReducer, guestSignupReducer, locationReducer, locationNameReducer, locationRadiusReducer, childLoginRestrictionReducer, notificationRefreshReducer, s3DataKeyReducer, filterReducer, initFilterReducer, TermsandConditionsReducer,ErrorNotificationReducer, googleMapLoadedReducer },
});


export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
